import React from "react";


export default function MoneyBackGuarantee () {
    return(
        <div>Money BAck Guarantee</div>
    )
}